import { render } from "./SurveyAnswer.vue?vue&type=template&id=108f4a78&scoped=true&ts=true"
import script from "./SurveyAnswer.vue?vue&type=script&lang=ts"
export * from "./SurveyAnswer.vue?vue&type=script&lang=ts"

import "./SurveyAnswer.vue?vue&type=style&index=0&id=108f4a78&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108f4a78"]])

export default __exports__